// ---------------------------------------------------------------------------
// Seleção de serviços do item (handoff 0039) — catálogo unificado N:N.
//
// O item deixou de classificar serviço em 4 colunas fixas de quantidade. Agora
// carrega uma SELEÇÃO `services[]` de serviços do catálogo unificado
// (technician_commission_table), cada um com quantidade:
//
//   services: [ { commission_table_id, service_code, service_description,
//                 quantity }, ... ]
//
// O tempo-padrão por serviço vive no catálogo (GET /routing/service-catalog,
// campo estimated_completion_service_time). Estes helpers indexam o catálogo
// por id (= commission_table_id da seleção) e calculam a duração sugerida.
// ---------------------------------------------------------------------------

// Indexa o catálogo por id → entrada do serviço. O id do catálogo é o
// commission_table_id usado nas seleções e nos payloads de item.
export function indexCatalogById(catalog) {
   const map = {};
   (catalog || []).forEach((entry) => {
      if (entry?.id != null) map[entry.id] = entry;
   });
   return map;
}

// Total de unidades selecionadas (Σ quantity). >0 = item tem ≥1 serviço
// associado (classificado). Aceita o array services[] do item adaptado/raw.
export function totalServiceQty(services) {
   if (!Array.isArray(services)) return 0;
   return services.reduce((acc, s) => acc + (Number(s?.quantity) || 0), 0);
}

// Duração sugerida (catálogo) = Σ ( quantity × estimated_completion_service_time ).
// services = [{ commission_table_id, quantity }]; catalogById = saída de
// indexCatalogById. Serviço sem tempo parametrizado (NULL) conta como 0.
export function suggestedDurationMinutes(services, catalogById) {
   if (!Array.isArray(services)) return 0;
   return services.reduce((acc, s) => {
      const entry = catalogById?.[s?.commission_table_id];
      const time = Number(entry?.estimated_completion_service_time) || 0;
      return acc + (Number(s?.quantity) || 0) * time;
   }, 0);
}
